import React, { useEffect } from 'react';
import styled from 'styled-components';
import Footer from 'components/footer';
import { COLOR } from 'constants/colors';
import { useForm } from 'react-hook-form';
import { useMediaQuery } from 'react-responsive';
import { SuccessButton } from 'components/button';
import { getQueryParamsFromString } from '__utils/common-utils';
import { PaymentFlowHelper } from '../paymentFlow.helper';
import { CommonStyledComponentProps } from '__utils/type';
import { propsToJS } from '__utils/immutable-to-js';
import { useSelector } from 'react-redux';
import PaymentViewSelector from '../payment-flow.selector';
import { FormErrorMessageSpan, InputMintDiv } from 'views/common-styled-components';

const Step2Container = styled.div<CommonStyledComponentProps>`
    width: ${(props: CommonStyledComponentProps) => props.isMobile ? "100%" : "80%"}

    label{
        font-weight: 500;
        font-size: 14px;
    }
`;

const Step = styled.div<CommonStyledComponentProps>`
    flex: 1;
    margin-bottom: 36px;
`;

const PayStep = styled.div<CommonStyledComponentProps>`

    position: relative;
    h5 {
        font-size: 16px;
        color: ${COLOR.GREEN};
        line-height: normal;
        font-weight: 500;
        padding: ${(props: CommonStyledComponentProps) => props.isMobile ? "0px" : "4px 0px"}
    }
`;

const UpiForm: React.FC = () => {

    const isMobile = useMediaQuery({ maxWidth: 767 });
    const { register, handleSubmit, formState } = useForm({ mode: 'onChange' });
    const {errors} = formState;
    const { makeBSEpayment, getBSEorderDetails } = PaymentFlowHelper();
    const { loopBackUrl } = getQueryParamsFromString(window.location.search);
    const { userPaymentDetailView } = propsToJS(useSelector(PaymentViewSelector));

    useEffect(() => {
        userPaymentDetailView && userPaymentDetailView?.length === 0 && getBSEorderDetails();
    }, [])

    const onProceed = (data: any) => {
        makeBSEpayment({ paymentMode: 3, vpaId: data.vpaId }, onUpiPaymentSuccess);
    }

    const onUpiPaymentSuccess = (response: any) => {
        window.location.replace(`${window.location.origin}/v1/${loopBackUrl}`);
    }

    return (
        <>
            <Step2Container isMobile={ isMobile }>

                <Step isMobile={ isMobile }>
                    <PayStep isMobile={ isMobile }>
                        <form id="upiForm" onSubmit={ handleSubmit(onProceed) } style={ { marginTop: '8px' } }>
                            <InputMintDiv>
                                <label htmlFor='vpaId'>Enter your VPA ID</label>
                                <input
                                    name='vpaId'
                                    style={ { width: isMobile ? '100%' : '' } }
                                    className="upiInput"
                                    id='vpaId'
                                    type="text"
                                    placeholder="abc@okaxis"
                                    ref={register({
                                        required: "Please enter VPA id",

                                    }) }
                                />
                                { errors.vpaId ? <FormErrorMessageSpan className="unsetCustStyle" style={ { marginLeft: '36px', marginTop: '8px' } }>{ errors.vpaId.message }</FormErrorMessageSpan> : null }
                            </InputMintDiv>
                        </form>
                        <p style={ { color: '#959595', fontSize: '12px', width: isMobile ? '100%' : '88%' } }>* Please enter the UPI ID of the primary bank account or the UPI ID of other bank accounts mapped in your BSE account to ensure that your transaction is successful.</p>
                    </PayStep>
                </Step>
                { isMobile ? <Footer>
                    <SuccessButton type="submit" form="upiForm" disabled={ !formState.isValid }>Confirm Payment</SuccessButton>
                </Footer> :
                    <SuccessButton type="submit" form="upiForm" disabled={ !formState.isValid }>Confirm Payment</SuccessButton>
                }
            </Step2Container>


        </>
    )
}

export default UpiForm;
